import {
  COMPANY_INDUSTRIES,
  type AccessStatus,
  type CompanyData,
  type CompanyIndustry,
  type CompanyKind,
  capitalize,
  isDefined,
  isEmpty,
} from '@terros/common'
import { type SelectItem } from '../types'

export const companyKinds: SelectItem<CompanyKind>[] = [
  { value: 'customer', label: 'Customer' },
  { value: 'demo', label: 'Demo' },
  { value: 'sandbox', label: 'Sandbox' },
  { value: 'template', label: 'Template' },
  { value: 'development', label: 'Development' },
]

export const accessStatuses: SelectItem<AccessStatus>[] = [
  { value: 'active', label: 'Active' },
  { value: 'suspended', label: 'Suspended' },
]

export const COMPANY_INDUSTRY_OPTIONS: SelectItem<CompanyIndustry>[] = COMPANY_INDUSTRIES.map((value) => ({
  value,
  label: getCompanyIndustryLabel(value),
}))

export function getCompanyIndustryLabel(industry: CompanyIndustry): string {
  switch (industry) {
    case 'home_improvement':
      return 'Home Improvement'
    case 'satellite_tv':
      return 'Satellite/TV'
    case 'solar_cleaning':
      return 'Solar Cleaning'
    default:
      return capitalize(industry)
  }
}

export function getCompanyIndustryLabels(industries: CompanyIndustry[] | undefined): string | undefined {
  if (isEmpty(industries)) return
  return industries.map(getCompanyIndustryLabel).join(', ')
}

// TODO compare with add
export function getLevelName(
  company: Pick<CompanyData, 'highestTeamLevel' | 'levelNames'> | undefined,
  level: number
): string {
  if (!company) {
    return 'Team'
  }
  const { highestTeamLevel, levelNames = {} } = company
  if (isDefined(highestTeamLevel) && highestTeamLevel < level) {
    return 'Team'
  }
  return levelNames[level] || getLevelName(undefined, level)
}
